exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-logo {\n  width: 100%; }\n\n.footer {\n  color: #ffffff;\n  width: 100%; }\n  .footer .contact-header {\n    margin: 0 0 1em; }\n  .footer .links {\n    width: 100%; }\n    .footer .links p {\n      width: 100%; }\n  .footer p {\n    color: #ffffff;\n    border-bottom: 1px solid #8f8f8f;\n    padding: 1em 5px;\n    margin: 0;\n    font-size: 0.9rem;\n    transition: all 200ms ease; }\n    .footer p:not(.contact-info):hover {\n      background: rgba(255, 255, 255, 0.2); }\n    .footer p.contact-info {\n      border: none;\n      margin: 0 0 10px;\n      padding: 0; }\n      .footer p.contact-info .fa {\n        width: 20px;\n        font-size: 1.1rem;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        margin: 0; }\n  .footer a {\n    color: #ffffff;\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 0.9rem; }\n\n@media screen and (max-width: 768px) {\n  .footer .contact-header {\n    padding-top: 10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = 287
// module chunks = 1